import React, { useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Spinner, FormGroup, Form, Container, Row, Col } from 'reactstrap';
import { ButtonLogin, InputLogin, CloseButton, AlertBox, FormWrapper, SpanText, } from './styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faTimesCircle, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import api from '../../services/client/api';
import cookie from '../../services/cookie/index';
import {  validarArquivoPDF, validarData, validarNome } from '../../utils/formValidations.js';
import ReCAPTCHA from "react-google-recaptcha";
import moment from 'moment';
import { isCpfValid } from '../../utils/cpfValidate.js';


const RegisterOther = ({ onClose }) => {
  const history = useHistory();
  const [name, setName] = useState('');
  const [birthday, setDataNasc] = useState('');
  const [procFile, setProcFile] = useState('');
  const [cpf, setCpf] = useState('');
  const [mother_name, setMotherName] = useState('');
  const [inProgress, setInProgress] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState('');
  const isMountedRef = useRef(true);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setInProgress(true);
        if (name === '') {
      alert('Por favor, informe o nome completo.');
      setInProgress(false);
      return;
    }
    
    if (!validarNome(name)) {
      alert('Nome inválido. Por favor, forneça um nome válido.');
      setInProgress(false);
      return;
    }
      
    if (mother_name === '') {
      alert('Por favor, informe o nome da mãe.');
      setInProgress(false);
      return;
    }
    
    if (!validarNome(mother_name)) {
      alert('Nome de mãe inválido. Por favor, forneça um nome de mãe válido.');
      setInProgress(false);
      return;
    }
      
    if (birthday === '') {
      alert('Por favor, informe a data de nascimento.');
      setInProgress(false);
      return;
    }
    
    if (!validarData(birthday)) {
      alert('Data de nascimento inválida. Verifique o formato e tente novamente.');
      setInProgress(false);
      return;
    }
      if (!isCpfValid(cpf)) {
      alert('CPF inválido.');
      setInProgress(false);
      return;
    }

    if (!validarArquivoPDF(procFile)) {
      alert('Arquivo PDF inválido. Verifique o formato e tente novamente.');
      setInProgress(false);
      return;
    }

    if (!recaptchaToken) {
      alert('Por favor, resolva o reCAPTCHA.');
      setInProgress(false);
      return;
    }

  
   
    const dataNascFormatada = moment(birthday, 'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ssZ');

   

    const formData = new FormData();
    formData.append('name', name);
    formData.append('birthday', dataNascFormatada);
    formData.append('mother_name', mother_name);
    formData.append('cpf', cpf.replace(/\D/g, ''));
    formData.append('id_categoria', 2);
    formData.append('recaptchaToken', recaptchaToken);


    if (procFile) {
      formData.append('procuracao', procFile);
    }
    

 
    try {
      const token = cookie().get('token');
      const response = await api().userPatient().registerUserPatient(formData, token);
    
      if (isMountedRef.current && response.id_user) {
        onClose();
        window.alert('Solicitação cadastrada com sucesso!');
        history.replace('/');
      } else {
        alert('Erro ao cadastrar paciente: Resposta inválida da API');
        setInProgress(false);
        return;
      }
    } catch (error) {

     

      if (error.message === 'CPF already exists') {
        alert('Este CPF já foi cadastrado.');
      } else if (error.message === 'Invalid reCAPTCHA'){
        alert('reCAPTCHA expirou. Atualize a página e tente novamente.');
      }else if (error.message === 'Error retrieving file'){
        alert('Falha ao receber arquivo. Atualize a página e tente novamente.');
      }
      else {
        alert('Ocorreu um erro. Tente novamente mais tarde.');
     }

    } finally {
  
    
      if (isMountedRef.current) {
        setInProgress(false);
      }
    }
  };    

  const handleDateChange = (e) => {
    let value = e.target.value.replace(/\D/g, '');

    if (value.length > 2) {
      value = `${value.slice(0, 2)}/${value.slice(2)}`;
    }
    if (value.length > 5) {
      value = `${value.slice(0, 5)}/${value.slice(5)}`;
    }

    setDataNasc(value);
  };

  const applyCpfMask = (value) => {
    const cleanedValue = value.replace(/\D/g, '');
    const match = cleanedValue.match(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})$/);
    if (match) {
      return `${match[1]}${match[2] ? '.' + match[2] : ''}${match[3] ? '.' + match[3] : ''}${match[4] ? '-' + match[4] : ''}`;
    }

    return value;
  };

  const onChangeCap = (value) => {
    setRecaptchaToken(value);
  };

  return (
    <FormWrapper>
<Container>
<AlertBox>
  <FontAwesomeIcon
    icon={faExclamationCircle}
    style={{ marginRight: '10px', color: '#721c24' }}
  />
  Este formulário permite solicitar acesso aos exames de pacientes por responsáveis autorizados.
  É necessário anexar um documento que comprove a representação legal do paciente,
  como uma procuração com assinatura digital ou, no caso de pais ou mães,
  a certidão de nascimento.
  
  <small style={{ display: 'block', marginTop: '5px', color: '#6c757d' }}>
    Em conformidade com a Lei Geral de Proteção de Dados (LGPD).
  </small>
  <small style={{ display: 'block', color: '#6c757d' }}>
    Lei nº 13.709/2018.
  </small>
</AlertBox>


  <Form onSubmit={handleSubmit}>
    <Row>

    <Col xs={12} md={6}>
      <FormGroup>
        <SpanText>
          Digite o nome do Paciente:
        </SpanText>
        <InputLogin
          type="text"
          placeholder="Digite o nome do Paciente"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
      </FormGroup>
    </Col>
    <Col xs={12} md={6}>
      <FormGroup>
        <SpanText>
          Digite o CPF do Paciente:
        </SpanText>
        <InputLogin
          type="text"
          placeholder="Digite o CPF do Paciente"
          value={applyCpfMask(cpf)}
          onChange={(e) => setCpf(e.target.value)}
          required
          maxLength="14"
        />
      </FormGroup>
    </Col>
  </Row>

  <Row>
    <Col xs={12} md={6}>
      <FormGroup>
        <SpanText>
          Nome da Mãe do Paciente:
        </SpanText>
        <InputLogin
          type="text"
          placeholder="Nome da Mãe do Paciente"
          value={mother_name}
          onChange={(e) => setMotherName(e.target.value)}
          required
        />
      </FormGroup>
    </Col>
    <Col xs={12} md={6}>
      <FormGroup>
        <SpanText>
          Data de Nascimento do Paciente:
        </SpanText>
        <InputLogin
          type="text"
          placeholder="Data de nascimento do Paciente"
          value={birthday}
          onChange={handleDateChange}
          maxLength="10"
          required
        />
      </FormGroup>
    </Col>
  </Row>
  <Row><Col xs={12} md={12}>
  <FormGroup>
   <SpanText>
    Anexe o arquivo contendo o documento de procuração com assinatura digital (PDF).  
    Para pais ou responsáveis legais do paciente, é aceita a certidão de nascimento (PDF).
  </SpanText>

    <InputLogin
      type="file"
      onChange={(e) => {
        const file = e.target.files[0];
        if (file && file.type === 'application/pdf') {
          setProcFile(file);
        } else {
          alert('Por favor, envie um arquivo no formato PDF.');
          e.target.value = ''; // Reseta o campo de arquivo se não for PDF
        }
      }}
    />
  </FormGroup>
  </Col>
  </Row>
   <ReCAPTCHA
      sitekey="6Le3muwrAAAAAB08JzLiDJRPCQFf041iEIfIQI_e"
      onChange={onChangeCap}
    />
  <Row>
    <Col xs={12} md={12}>
      <ButtonLogin type="submit" disabled={inProgress}>
        {inProgress ? <Spinner size="sm" color="light" /> : 'Enviar solicitação'}
        {!inProgress && <FontAwesomeIcon icon={faArrowRight} style={{ marginLeft: '10px' }} />}
      </ButtonLogin>
    </Col>
  </Row>
  </Form>

      <CloseButton>
        <FontAwesomeIcon icon={faTimesCircle} onClick={onClose} />
      </CloseButton>

      </Container>
    </FormWrapper>
  );
};

export default RegisterOther;
